'use strict';

// Expand.js
// Handles expanding and collapsing elements

class Expand {
    wrap;
    ui;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                toggle: $(this.wrap).find('.js-expand-toggle')
            };
        }

        if (this.ui.toggle) {
            this.bindUIActions();
        }

    }

    bindUIActions() {
        if (this.ui.toggle.length) {
            this.ui.toggle.each((index, el) => {
                el.addEventListener('click', (e) => this.toggleClick(e));
                el.addEventListener('keypress', (e) => this.toggleKeyPress(e));
            });
        }
    }

    toggleClick(e) {
        e.preventDefault();
        this.toggleExpandList();
    }

    toggleKeyPress(e) {
        e.preventDefault();
        if (e.which === 13) {
            this.toggleExpandList();
        }
    }

    toggleExpandList() {
        if (this.wrap.classList.contains('is-collapsed')) {
            this.wrap.classList.remove('is-collapsed');
            this.wrap.classList.add('is-expanded');
        } else if (this.wrap.classList.contains('is-expanded')) {
            this.wrap.classList.remove('is-expanded');
            this.wrap.classList.add('is-collapsed');
        }
    }

}

export default Expand;
